import React, { useState } from "react";
import log from "loglevel";
import Report from "powerbi-report-component";
import { Col, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactTooltip from "react-tooltip";
import styles from "./PowerBiReport.module.scss";

const PowerBiReport = ({
  embedToken,
  embedUrl,
  reportId,
  isEmbedded,
  isWithReportSelectDropdown,
}: {
  embedToken: string | undefined;
  embedUrl: string | undefined;
  reportId: string | undefined;
  isEmbedded: boolean;
  isWithReportSelectDropdown: boolean;
}) => {
  const [report, setReport] = useState<any>();

  const handleReportLoad = (report: any) => {
    setReport(report);
  };

  const handleReportRender = (report: any) => {
    setReport(report);
  };

  const handleDataSelected = (data: any) => {
    log.info("Data Selected: %o", data);
  };

  const handlePageChange = (data: any) => {
    log.info("Page Selected: %o", data);
  };

  const handleTileClicked = (data: any) => {
    log.info("Data from tile: %o", data);
  };

  const setFullscreen = () => {
    if (report !== undefined) report.fullscreen();
  };

  const printReport = () => {
    if (report) report.print();
  };

  const generateToolbar = () => {
    return (
      <div className={styles["icon-bar"]}>
        <div
          role="button"
          data-tip="Fullscreen"
          data-for="powerbi-toolbar-tooltip"
          onClick={setFullscreen}
        >
          <FontAwesomeIcon
            className={styles["icon-bar__icon"]}
            icon={["fal", "expand"]}
          />
        </div>
        <div
          role="button"
          data-tip="Print"
          data-for="powerbi-toolbar-tooltip"
          onClick={printReport}
        >
          <FontAwesomeIcon
            className={styles["icon-bar__icon"]}
            icon={["fal", "print"]}
          />
        </div>
        <div
          role="button"
          data-tip="Reload"
          data-for="powerbi-toolbar-tooltip"
          onClick={() => (window.location.reload as any)(true)}
        >
          <FontAwesomeIcon
            className={styles["icon-bar__icon"]}
            icon={["fal", "sync-alt"]}
          />
        </div>
        <ReactTooltip
          id="powerbi-toolbar-tooltip"
          place="left"
          effect="solid"
        />
      </div>
    );
  };

  const extraSettings = {
    filterPaneEnabled: false,
    navContentPaneEnabled: true,
  };

  return (
    <>
      <Col
        id="powerbi-view-col"
        xs={isWithReportSelectDropdown ? 10 : 12}
        sm={isWithReportSelectDropdown ? 10 : 12}
        md={isWithReportSelectDropdown ? 8 : 10}
        lg={isWithReportSelectDropdown ? 9 : 10}
        xl={isWithReportSelectDropdown ? 9 : 10}
      >
        {embedToken && embedUrl && reportId ? (
          <Card className={styles[isEmbedded ? "pbi-card-embed" : "pbi-card"]}>
            {/* !report ? <p>Loading...</p> : null */}
            <Report
              style={{ height: "100%", width: "100%" }}
              embedType="report" // or "dashboard"
              tokenType="Embed" // or "Aad"
              accessToken={embedToken} // accessToken goes here
              embedUrl={embedUrl} // embedUrl goes here
              embedId={reportId} // Report or Dashboard ID goes here
              permissions="View" // or "View"
              extraSettings={extraSettings}
              onRender={handleReportRender}
              onSelectData={handleDataSelected}
              onPageChange={handlePageChange}
              onTileClicked={handleTileClicked}
            />
          </Card>
        ) : null}
      </Col>
      <Col id="powerbi-toolbar-col" xs={12} sm={12} md={1} lg={1} xl={1}>
        {generateToolbar()}
      </Col>
    </>
  );
};

export default PowerBiReport;
